<template>
  <form-panel
    width="short"
    @closePanel="onCloseModal">
    <div class="content-note">
      <h3>{{ currentNote.title }}</h3>
      <h5>Creado por: {{ profile.name }}</h5>
      <p>Fecha:</p>
      <p><strong>{{ currentNote.createdAt | date('DD/MM/YYYY') }}</strong></p>
      <p>Fecha programada para activación:</p>
      <p><strong>{{ currentNote.dueDate | date('DD/MM/YYYY') }}</strong></p>
      <h5 >Descripción:</h5>
      <h5> <strong>{{ currentNote.content }}</strong></h5>
      <el-row>
        <el-col :span="12">
          <el-checkbox @change="onSelect">¿Asignar una oportunidad?</el-checkbox>
        </el-col>
      </el-row>
      <el-row>
        <el-col
          :span="12"
          class="el-select">
          <el-select
            v-model="currentNote.opportunityId"
            :disabled="onCheck"
            class="el-select"
            placeholder="Elija una oportunidad">
            <el-option
              v-for="(oportunity, index) in opportunities"
              :key="index"
              :label="oportunity.title"
              :value="oportunity.id"/>
          </el-select>
        </el-col>
      </el-row>
      <div class="save">
        <el-button
          :disabled="onCheck"
          type="primary"
          style="width: 100%"
          @click="updateNote(currentNote)">
          Asignar
        </el-button>
      </div>
    </div>
  </form-panel>
</template>

<script>
import FormPanel from '@/components/_shared/form-panel'
import http from '@/services/http.service'

export default {
  name: 'TasksCreateView',
  components: {
    FormPanel
  },
  props: {
    currentNote: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      opportunities: [],
      opportunityItem: '',
      onCheck: true
    }
  },
  computed: {
    profile () {
      return this.$store.getters['profile/me']
    }
  },
  mounted () {
    http.get('opportunities', {})
      .then(response => {
        this.opportunities = response.data.items
      })
  },
  methods: {
    onCloseModal () {
      this.$store.dispatch('app/togglePrevNotesPanel')
    },
    onSelect () {
      this.onCheck = !this.onCheck
    },
    updateNote (model) {
      this.$store.dispatch('notes/save', model)
        .then(response => {
          this.$message.success('La nota se ha actualizado con éxito')
        })
        .catch(e => {
          this.$message.error('La nota no pudo ser actualizada')
          model.completed = !model.completed
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-note{
    height: 100vh;
    position: relative;
    padding: 20px 20px 0 20px;
    .el-select{
      margin-top: 10px;
    }
    .save{
      height: 60px;
      padding: 20px 0;
      position: relative;
      button{
        position: absolute;
        right: 0px;
        box-shadow: 0 3px 6px 0 rgba(231, 18, 14, 0.5);
      }
    }
    h3{
      margin: 0;
      @include font-lato(21px, regular);
      color: #707070;
    }
    p {
      @include font-lato(14px, regular);
      color:#3E3E3E;
    }
    h4{
      @include font-lato(12px, bold);
      color: #3E3E3E;
    }
    .check{
      @include font-lato(12px, bold);
      color: #3E3E3E;
    }
    h5{
      @include font-primary(13px, regular);
      color: #707070;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/app/notes/notes-preview.vue